import React, { useEffect, useState } from "react";
import "./Header.css";
import {
  MdAccountCircle,
  MdFavorite,
  MdShoppingCart,
  MdHome,
} from "react-icons/md";
import { IoIosCall } from "react-icons/io";
import { GiHamburgerMenu } from "react-icons/gi";
import { Link, useNavigate } from "react-router-dom";
import Loginform from "./Loginform";
import Viewcartitem from "../../Screens/Viewcartitem";
import { useSelector, useDispatch } from "react-redux";
import { Scrollbars } from "react-custom-scrollbars-2";
import {
  PoductsApi,
  ChangeName,
  BrandPoductsApi,
  MoreData,
} from "../Redux/Action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "./../../assets/defaultImage.png";
import SocialMedia from "./SocialMedia";
import SocialMedia2 from "./SocialMedia2";

// Header

const Header = () => {
  const [acountname, setAcountname] = useState(window.accountname);
  // setAcountname(window.accountname)

  const dispatch = useDispatch();
  const [searchPro, setSearchPro] = useState("");
  const cartItems = useSelector((state) => state.Reducer);
  const DepartmentData = useSelector((state) => state.ReducerDepData);
  const lengthItem = cartItems.length;
  const [brandData, setBrandData] = useState(null);
  const navigate = useNavigate();
  const [X, setX] = useState(false);
  const [toggleLogin, setToggleLogin] = useState(false);
  const [opencart, setOpencart] = useState(false);
  const [depData, setDepData] = useState(null);
  const [depHading, setDepHading] = useState();
  const [sabdepHading, setSabdepHading] = useState();
  const [brandDisplay, setBrandDisplay] = useState("none");
  const getBrand = useSelector((state) => state.ReducerBrandsData);

  useEffect(() => {
    if (DepartmentData !== "abc") {
      const updatedData = DepartmentData.map((item) => {
        item.isShown = false;
        return { ...item };
      });
      setDepData(updatedData);
    }

    // if (getBrand !== 'abc') {
    //   const updatedData = getBrand.map((item) => {
    //     item.isShown = false;
    //     return { ...item }
    //   })

    //   setBrandData(updatedData)
    // }
    brand_Api();
  }, [DepartmentData]);

  // useEffect(()=>{
  //   brand_Api()
  // },[])

  async function brand_Api() {
    let response = await fetch(
      `${window.sbapi}/api/product/getbrands?BusinessId=0000000001`
    );

    response = await response.json();

    // setBrandData(response)
    let d = await response.data.map((it, k) => {
      it.isShown = false;
      return { ...it };
    });
    setBrandData(d);
  }

  // const sbapi = "https://easyapi.sbstorefsd.com"
  //vapeapi.vaperepublic.pk

  const getCooki = (cookiname) => {
    let cname = cookiname + "=";
    let csplit = document.cookie.split(";");
    for (let i = 0; i < csplit.length; i++) {
      let c = csplit[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(cname) == 0) {
        return c.substring(cname.length, c.length);
      }
    }
    return "";
  };

  const searchHandler = async (key) => {
    // let key = event.target.value;

    if (key.length > 2) {
      console.warn(`Search key ${key}`);
      let result = await fetch(
        `${window.sbapi}/api/Product/ProductsByName?BusinessId=0000000001&Name=${key}`
      );
      result = await result?.json();
      let sortdata = result?.data;

      if (sortdata?.length > 0) {
        const a = sortdata?.map((item) => {
          item.qty = 1;
          item.departmentName = item.departmentCode;
          return { ...item };
        });
        // const b = sortdata.map(item =>{
        // {item.departmentName = item.departmentDatan}
        // return {...item}
        // })
        setSearchPro(a);
      }
    } else {
      setSearchPro("");
    }
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        theme="colored"
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div class="full-header">
        <div className="marquee-container">
          <marquee className="marquee-text" direction="right">
            کے بعد ملنے والا آرڈر اگلے دن ڈیلیور کیا جائے گا ۔ PM 10:00
            &nbsp;فاسٹ فوڈ کی سہولت صرف چیچہ وطنی میں موجود ہے ۔ چیچہ وطنی اور
            میاں چنوں کے ملحقہ گاؤں میں ہوم ڈیلیوری صرف 31 جولائی 2025 تک فری ہے
            ۔ اس کے بعد چار جز لاگو ہوں گے ۔ ملحقہ گاؤں کا آرڈر کم از کم تین
            ہزار روپے کا ہونا ضروری ہے۔
          </marquee>
        </div>

        {/* Topbar use for responsive   */}
        <div className="topbar">
          <a>
            {" "}
            <Link to={"/contactus"}> sales@superduper.pk </Link>
          </a>
          <a href="tel:+923330333183" className="call">
            {" "}
            <IoIosCall size="12px" /> +92 333 0333 183{" "}
          </a>
        </div>

        {/* Navbar or Header */}
        <nav className="navbar">
          {/* First Logo */}

          <div className="logo">
            <Link to={"/"}>
              <img
                src={logo}
                alt="Super Duper Store"
                style={{ height: 200, width: 200 }}
              />
            </Link>

            <div>
              {/* <h2> Super Duper  </h2> */}
              {/* <h4> FAISALABAD</h4> */}
            </div>
          </div>

          {/* Second Search Bar  */}

          <div className="search-bar" style={{ position: "relative" }}>
            <input
              className="input"
              type="search"
              placeholder="Search Product"
              onChange={(e) => searchHandler(e.target.value)}
            />
          </div>

          <span className="search-container">
            <Scrollbars
              autoHeight
              autoHeightMin={0}
              autoHeightMax={200}
              style={{ position: "relative", margin: 0 }}
            >
              {searchPro
                ? searchPro.map((item, key) => {
                    return (
                      <Link
                        key={key}
                        className="search-product-container"
                        to={"/productdetail"}
                        state={{ item }}
                      >
                        <Link
                          className="search-imag"
                          to={"/productdetail"}
                          state={{ item }}
                        >
                          <img
                            src={`${window.imagesapi}/images/ProductImages/${item?.barcode}.webp?v=${item?.updateTicks}`}
                          />
                        </Link>
                        <Link to={"/productdetail"} state={{ item }}>
                          <p className="item-desc">{item.description}</p>
                        </Link>
                        {/* <span className='cr-price'>Rs.{item.unitRetail}</span> */}
                      </Link>
                    );
                  })
                : ""}
            </Scrollbars>
          </span>

          {/* Third Icon or Social Media Part */}

          <SocialMedia />
        </nav>

        {/* Main Menu Naver bar bar  */}
        <div
          style={{
            zIndex: 100,
            position: "absolute",
            display: brandDisplay,
            justifyContent: "center",
            marginLeft: "104px",
            marginTop: "37px",
            backgroundColor: "white",
            flexDirection: "column",
            width: "160px",
            position: "absolute",
            boxShadow: "rgba(0, 0, 0, 0.16) 4px 4px 20px",
          }}
        >
          <div
            onMouseLeave={() => setBrandDisplay("none")}
            onMouseOver={() => setBrandDisplay("flex")}
          >
            {brandData?.map((item, key) => {
              return (
                <Link
                  key={item?.code}
                  to={"/brandProducts"}
                  className="menu_container"
                  onMouseOver={() => {
                    brandData[key].isShown = true;
                    setBrandData([...brandData]);
                  }}
                  onMouseLeave={() => {
                    brandData[key].isShown = false;
                    setBrandData([...brandData]);
                  }}
                >
                  <div
                    className="brand-list-style"
                    style={{ borderBottom: "1px solid gray" }}
                    onClick={() => {
                      // e.preventDefault()
                      // dispatch(setBrandInfo(item))

                      setBrandDisplay("none");
                      dispatch(BrandPoductsApi(item.code));
                      localStorage.setItem("code", item.code);

                      navigate("/brandProducts");
                    }}
                  >
                    {" "}
                    {item?.name}{" "}
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
        <nav className="main-menu">
          <p className="homeBtn">
            <Link to={"/"}>
              <MdHome className="homeIcon" />
            </Link>
          </p>
          <Link
            id="a123"
            to={"/brandProducts"}
            // bgcolor={bgcolor}
            onClick={() => {
              dispatch(BrandPoductsApi("all-data"));
              localStorage.setItem("code", "all-data");
            }}
            className="menu_container"
            style={{
              backgroundColor: "black",
              paddingTop: "0px",
              paddingRight: "0px",
              paddingLeft: "15px",
            }}
            onMouseLeave={() => {
              document.getElementById("a123").style.backgroundColor = "black";
              setBrandDisplay("none");
            }}
            onMouseEnter={() =>
              (document.getElementById("a123").style.backgroundColor = "white")
            }
            onMouseOver={() => {
              setBrandDisplay("flex");
            }}
          >
            <p style={{ marginTop: "10px", position: "relative" }}>
              BRANDS
              <img
                style={{ marginLeft: "5px", marginTop: "10px" }}
                width="10px"
                height="5px"
                src="drop.png"
              />
            </p>
          </Link>

          {depData?.map((item, index) => {
            return (
              <Link
                to={"/productspage"}
                className="menu_container"
                onMouseOver={() => {
                  depData[index].isShown = true;
                  setDepData([...depData]);
                  setBrandDisplay("none");
                }}
                onMouseLeave={() => {
                  depData[index].isShown = false;
                  setDepData([...depData]);
                }}
                onClick={(e) => {
                  var data = (depData[index].value = item.departmentCode);
                  let data3 = {
                    dep: data,
                    grup: "",
                    count: 0,
                  };
                  dispatch(ChangeName(data3));
                  // dispatch(ChangeName(data))
                  var dep = (depData[index].value = item.departmentCode);
                  dispatch(PoductsApi(dep, ""));
                  e.stopPropagation();
                  dispatch(MoreData([]));

                  // if(dep.data == null){
                  //   return("product Is Not Available")
                  //   // setDepData("Product Is Not Available")
                  // }
                  // alert(window.ghadding )
                }}
              >
                <p>{item.departmentName}</p>
                <span style={{ position: "absolute" }} className="sab_menu">
                  {item?.groups?.map((it) => {
                    return item.isShown ? (
                      <Link
                        to={"/productspage"}
                        onClick={(e) => {
                          var data1 = (depData[index].value =
                            item.departmentName);
                          var depsab = (depData[index].value = it.groupName);
                          var data = data1 + " >> " + depsab;
                          // dispatch(ChangeName(data))

                          var dep = (depData[index].value =
                            item.departmentCode);
                          var grup = (depData[index].value = it.groupCode);
                          let data3 = {
                            dep: dep,
                            grup: grup,
                          };
                          dispatch(ChangeName(data3));

                          dispatch(PoductsApi(dep, grup));
                          e.stopPropagation();
                          dispatch(MoreData([]));

                          // if(grup.data == null){
                          //   return(<p>product Is Not Available</p>)
                          // }
                          // alert("Department " + dep + "  " + "Group " + grup)
                        }}
                      >
                        <p>{it.groupName}</p>
                      </Link>
                    ) : null;
                  })}
                </span>
              </Link>
            );
          })}
        </nav>

        {/* Second Main Menu For Media Query Responsivenes */}

        <hr color=" rgb(0,90,181)"></hr>

        <nav className="main-menu2">
          {/* Hambarger Icon and onclick Function for Mian Menu Responsive  */}

          <div className="hamb">
            <a
              onClick={() => {
                setX(!X);
                // if (document.getElementsByClassName("ham-display").style.width === "0px") {
                //   document.getElementsByClassName("ham-display").style.height = "720px";
                //   document.getElementsByClassName("ham-display").style.width = "200px";
                //   // console.log("ham burgur")
                // }
                // else {
                //   document.getElementsByClassName("ham-display").style.height = "0";
                //   document.getElementsByClassName("ham-display").style.width = "0";
                //   // console.log("ham no burgur")
                // }
              }}
            >
              <GiHamburgerMenu size="22px" color="white" align-itamm="left" />
            </a>
            <div className={X ? "ham-display" : "ham-not-display"}>
              {depData?.map((item, index) => {
                return (
                  <Link
                    to={"/productspage"}
                    className="menu_container"
                    // onTouchStart={() => {
                    //   depData[index].isShown = true
                    //   setDepData([...depData])
                    // }}
                    // onTouchEnd={() => {
                    //   depData[index].isShown = false
                    //   setDepData([...depData])
                    // }}

                    onClick={(e) => {
                      // var data = depData[index].value = item.departmentName;
                      // dispatch(ChangeName(data))
                      // var dep = depData[index].value = item.departmentCode;
                      // dispatch(PoductsApi(dep, ''))

                      // e.stopPropagation();
                      var data = (depData[index].value = item.departmentCode);
                      let data3 = {
                        dep: data,
                        grup: "",
                        count: 0,
                      };
                      dispatch(ChangeName(data3));
                      // dispatch(ChangeName(data))
                      var dep = (depData[index].value = item.departmentCode);
                      dispatch(PoductsApi(dep, ""));
                      e.stopPropagation();
                      dispatch(MoreData([]));

                      setX(!X);
                    }}
                  >
                    <p>{item.departmentName}</p>

                    {/* <span style={{ position: 'absolute' }} className='sab_menu'>
                      {
                        item.groups.map((it) => {
                          return (
                            item.isShown ?
                              <Link to={'/productspage'} onClick={(e) => {
                                var dep = depData[index].value = item.departmentCode;
                                var grup = depData[index].value = it.groupCode;
                                dispatch(PoductsApi(dep, grup));
                                e.stopPropagation();
                              }} >
                                <p>{it.groupName}</p>
                              </Link>
                              : null
                          )
                        })
                      }
                    </span> */}
                  </Link>
                );
              })}
            </div>
          </div>

          {/* Responsive Search bar */}

          <div className="search-bar2">
            <input
              className="input"
              type="search"
              placeholder="Search Product"
              onChange={(e) => searchHandler(e.target.value)}
            />
          </div>

          {/*  Icon or Social Media Part for Responsive  */}

          <SocialMedia2 />
        </nav>
      </div>
    </>
  );
};

export default Header;
